<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="label">{{ $t('page.generic.name') }} <required-field /> - <small><span v-if="modelData.label" v-text="(max - modelData.label.length) + '/'"></span>{{ max }} caratteri rimanenti</small></label>
                <b-form-input aria-describedby="labelField" :state="errors.some((e) => e.field === 'label')?false:null" type="text" id="label" v-model="modelData.label" :maxlength="max"  aria-required="true" :required=true :value="modelData.label"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label for="description">{{ $t('page.generic.description') }}</label>
                <b-form-textarea aria-describedby="descriptionField" :state="errors.some((e) => e.field === 'description')?false:null"
                                 type="text" id="description" v-model="modelData.description"></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label>{{ $tc('page.generic.category', 2) }}</label>
                <v-select v-model="modelData.categories" multiple :options="categories"></v-select>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label>{{ $tc('page.generic.processType', 2) }}</label>
                <v-select v-model="modelData.processType" multiple :options="processType"></v-select>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label>{{ $tc('page.generic.format', 1) }} <required-field /></label>
                <v-select :class="errors.some((e) => e.field === 'modelFormat') ? 'error' :''" v-model="modelData.modelFormat" :options="formats"></v-select>
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group>
                <label>{{ $tc('page.generic.cda2Enclose', 1) }}</label> <br>
                <c-switch
                  class="mx-1"
                  v-model="modelData.attachCda2Enable"
                  color="success"
                  variant="pill"
                  :disabled="modelData.modelFormat !== 'PDF'"
                  label/>
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group>
                <label>{{ $tc('page.generic.state', 1) }}</label> <br>
                <c-switch class="mx-1" v-model="modelData.enabled" color="success" variant="pill" label/>
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group>
                <label>{{ $tc('page.generic.qrCodeEnabled', 1) }}</label> <br>
                <c-switch
                  class="mx-1"
                  v-model="modelData.qrcodeEnabled"
                  color="success"
                  variant="pill"
                  :disabled="modelData.modelFormat !== 'PDF'"
                  label/>
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group>
                <label>{{ $t('page.generic.cda2') }}</label> <br>
                <c-switch
                  class="mx-1"
                  v-model="modelData.injectCda2Enabled"
                  color="success"
                  variant="pill"
                  label
                  :disabled="modelData.modelFormat !== 'PDF'"/>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label for="documentTypes">{{ $tc('title.documentType', 1) }}</label>
                <v-select multiple id="documentTypes" :options="options"
                          v-model="modelData.documentTypes"
                          @search="onSearch">
                  <template slot="no-options">
                    Scrivi per cercare la DocumentType..
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    {{option.label}} ({{option.code}})
                  </template>
                  <template slot="option" slot-scope="option">
                    {{option.label}} ({{option.code}})
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-card no-body>
                <b-card-header style="cursor: pointer;" v-b-toggle.jsonSchemaCollapsed @click="jsonSchemaCollapsed = !jsonSchemaCollapsed">
                  <label>{{ $t('page.generic.jsonSchema') }}</label>
                  <i class="fa fa-lg float-right" :class="jsonSchemaCollapsed ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </b-card-header>
                <b-collapse visible id="jsonSchemaCollapsed">
                  <codemirror id="jsonSchema" v-model="modelData.jsonSchema" :options="cmOptions"></codemirror>
                </b-collapse>
              </b-card>
            </b-col>
            <b-col sm="12" v-if="canViewJasperJrxmlEditor">
              <b-card no-body>
                <b-card-header style="cursor: pointer;" v-b-toggle.jrxmlLinkedCollapse @click="isJrxmlLinkedCollapsed = !isJrxmlLinkedCollapsed">
                  <label>{{ $t('page.generic.jrxmlLinked') }}</label>
                  <i class="fa fa-lg float-right" :class="isJrxmlLinkedCollapsed ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </b-card-header>
                <b-collapse visible id="jrxmlLinkedCollapse">
                  <b-card-body>
                    <b-row>
                      <b-col sm="12">
                        <b-form-group v-for="(jasperUri, index) in modelData.jasperUris" :key="index">
                          <b-input-group>
                            <b-input-group-prepend>
                              <b-btn :disabled="index === 0" v-on:click="pullUp(index)" :variant="index === 0?'':'warning'"><i class="fas fa-arrow-up"></i></b-btn>
                            </b-input-group-prepend>
                            <b-input-group-prepend>
                              <b-btn :disabled="index === (modelData.jasperUris.length - 1)" v-on:click="pullDown(index)" :variant="index === (modelData.jasperUris.length - 1)?'':'warning'"><i class="fas fa-arrow-down"></i></b-btn>
                            </b-input-group-prepend>
                            <b-form-input disabled type="text" id="jasperUris" v-model="modelData.jasperUris[index]" aria-required="true"></b-form-input>
                            <b-input-group-append>
                              <b-btn variant="secondary" @click="showModal(index)"><i class="fas fa-file-import"></i></b-btn>
                            </b-input-group-append>
                            <b-input-group-append>
                              <b-btn v-on:click="removeElement(index)" variant="danger" class="mr-1"><i class="fas fa-trash-alt"></i></b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col sm="12">
                        <button class="btn btn-success float-left" type="button" @click="addElement"><i class="fas fa-plus"></i></button>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </b-col>
            <b-col sm="12" v-if="canViewCDA2Editor">
              <b-card no-body>
                <b-card-header style="cursor: pointer;" v-b-toggle.cda2LinkedCollapse @click="isCda2LinkedCollapsed = !isCda2LinkedCollapsed">
                  <label>{{ $t('page.generic.cda2Linked') }}</label>
                  <i class="fa fa-lg float-right" :class="isCda2LinkedCollapsed ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </b-card-header>
                <b-collapse visible id="cda2LinkedCollapse">
                  <b-card-body>
                    <b-row>
                      <b-col sm="12">
                        <b-form-group>
                          <b-input-group>
                            <b-form-input disabled type="text" id="cda2Uri" v-model="modelData.cda2Uri" aria-required="true"></b-form-input>
                            <b-input-group-append>
                              <b-btn variant="secondary" @click="showCda2TemplateModal"><i class="fas fa-file-import"></i></b-btn>
                            </b-input-group-append>
                            <b-input-group-append>
                              <b-btn @click="removeCda2Uri" variant="danger" class="mr-1"><i class="fas fa-trash-alt"></i></b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </b-col>
            <b-col sm="12">
              <b-card no-body>
                <b-card-header style="cursor: pointer;" v-b-toggle.signerCollapse @click="isSignerCollapsed = !isSignerCollapsed">
                  <label>{{ $tc('page.generic.signer', 2) }} - <small>{{ $t('model.signersLabel') }}</small></label>
                  <i class="fa fa-lg float-right" :class="isSignerCollapsed ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </b-card-header>
                <b-collapse visible id="signerCollapse">
                  <b-card-body>
                    <b-row>
                      <b-col sm="12">
                        <b-form-group v-for="(signature, index) in signatures" :key="index">
                          <b-input-group>
                            <b-input-group-prepend>
                              <b-btn :disabled="index === 0" v-on:click="pullUpSignature(index)" :variant="index === 0?'':'warning'"><i class="fas fa-arrow-up"></i></b-btn>
                            </b-input-group-prepend>
                            <b-input-group-prepend>
                              <b-btn :disabled="index === (signatures.length - 1)" v-on:click="pullDownSignature(index)" :variant="index === (signatures.length - 1)?'':'warning'"><i class="fas fa-arrow-down"></i></b-btn>
                            </b-input-group-prepend>
                            <b-form-select id="signatures" aria-required="true" v-model="signatures[index]"
                                           :options="[{value: 'patient', text: 'Paziente (o chi ne fa le veci)'}, {value: 'operator', text: 'Operatore'}]"></b-form-select>
                            <b-input-group-append>
                              <b-btn v-on:click="removeSignature(index)" variant="danger" class="mr-1"><i class="fas fa-trash-alt"></i></b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col sm="12">
                        <button class="btn btn-success float-left" type="button" @click="addSignature"><i class="fas fa-plus"></i></button>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col sm="12">
              <button class="btn btn-success float-right padder" type="button" @click="handleCreateModel()">
                {{ $t('actions.save') }}
              </button>
              <router-link class="btn btn-primary float-right" role="button" :to="{path: `/models`}" push>
                {{ $t('actions.abort') }}
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-modal class="mh-75" title="Seleziona JASPER" size="lg" centered v-model="myModal" @ok="handleOk">
        <b-tree-view v-if=treeData :data="treeData" :contextMenu=false :contextMenuItems=[] @nodeSelect="nodeSelect"></b-tree-view>
      </b-modal>
    </b-row>
    <b-row>
      <b-modal class="mh-75" title="Seleziona CDA2" size="lg" centered v-model="cda2TemplateModal" @ok="cda2TemplateModalHandleOk">
        <b-tree-view v-if=treeCda2Data :data="treeCda2Data" :contextMenu=false :contextMenuItems=[] @nodeSelect="cda2NodeSelect"></b-tree-view>
      </b-modal>
    </b-row>
    <b-modal
      class="modal-warning"
      header-bg-variant="warning"
      :title="$t('modal.saveModelWithoutSignatures.title')"
      v-model="saveModalWithoutSignatures"
      @ok="handleCreateModel(true)"
      :okTitle="$t('page.generic.proceed')"
      ok-variant="warning"
      :cancelTitle="$t('actions.abort')">
      {{ $t('modal.saveModelWithoutSignatures.text') }}
    </b-modal>
    <b-modal
      class="modal-warning"
      header-bg-variant="warning"
      :title="$t('modal.saveModelWithOralProcessType.title')"
      v-model="saveModalWithOral"
      @ok="createModel"
      :okTitle="$t('page.generic.proceed')"
      ok-variant="warning"
      :cancelTitle="$t('actions.abort')">
      {{ $t('modal.saveModelWithOralProcessType.text') }}
    </b-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import vSelect from 'vue-select'
  import {Switch as cSwitch} from '@coreui/vue'
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '../../components/PageTitle'
  import { bTreeView } from 'bootstrap-vue-treeview'
  import VueQuillEditor from 'vue-quill-editor'
  import {codemirror} from 'vue-codemirror'
  // require styles
  import 'codemirror/lib/codemirror.css'
  import 'codemirror/mode/javascript/javascript.js'

  import DocumentTypeService from '@/services/DocumentTypeService'
  const documentTypeService = DocumentTypeService.build();
  import {_} from 'vue-underscore';
  import RequiredField from "../../components/RequiredField";

  // mount with global
  Vue.use(VueQuillEditor);

  export default {
    name: 'modelEdit',
    inheritAttrs: false,
    components: {
      RequiredField,
      vSelect,
      bTreeView,
      cSwitch,
      PageTitle,
      codemirror
    },
    data() {
      return {
        isJrxmlLinkedCollapsed: true,
        isCda2LinkedCollapsed: true,
        jsonSchemaCollapsed: true,
        isSignerCollapsed: true,
        saveModalWithoutSignatures: false,
        saveModalWithOral: false,
        options: [],
        modelData: {
          processType: [],
          cdaType: 'CDA',
          jasperUris: [""],
          cda2Uri: ''
        },
        max: 256,
        categories: [],
        processType: [],
        myModal: false,
        cda2TemplateModal: false,
        formats: [],
        jasperItems: [],
        treeData: [{"id": 2, "name": "Venus" , "children": [{"id": 3, "name": "Neptune"}, {"id": 4, "name": "Stratus"} ] } ],
        treeCda2Data: [{"id": 2, "name": "Venus" , "children": [{"id": 3, "name": "Neptune"}, {"id": 4, "name": "Stratus"} ] } ],
        currentJasperIndex: null,
        selectedNode: null,
        cda2SelectedNode: null,
        errors: [],
        signatures: [''],
        cmOptions: {
          tabSize: 4,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          mode: 'text/javascript',
          lineWrapping: true,
          theme: 'default'
        }
      }
    },
    created() {
      miniToastr.init(); // config can be passed here miniToastr.init(config)
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
      // Aggiungo le categorie alla select
      this.getCategories();
      this.getProcessType();
      // Aggiungo i formati
      this.getFormats();
      this.getTree();
    },
    computed: {
      canViewCDA2Editor: function () {
        return this.modelData.modelFormat === "CDA2" ||
          (this.modelData.modelFormat === "PDF" &&
            (this.modelData.injectCda2Enabled === true|| this.modelData.attachCda2Enable === true)
          )
      },
      canViewJasperJrxmlEditor: function () {
        return this.modelData.modelFormat === "PDF"
      }
    },
    watch: {
      'modelData.modelFormat': function (val) {
          if(val === 'PDFA3') {
            this.modelData.injectCda2Enabled = false
            this.modelData.qrcodeEnabled = false
          }else if(val !== 'PDF'){
          this.modelData.injectCda2Enabled = false
          this.modelData.attachCda2Enable = false
        }
      },
      'modelData.injectCda2Enabled': function (val) {
        if(val === true) {
          this.modelData.attachCda2Enable = false
        }
      },
      'modelData.attachCda2Enable': function (val) {
        if(val === true) {
          this.modelData.injectCda2Enabled = false
        }
      }
    },
    methods: {
      handleCreateModel(fromWithoutSignatures = false) {
        if(this.signatures.filter(element => element != '').length === 0 && !fromWithoutSignatures)
          this.saveModalWithoutSignatures = true;
        else if (this.modelData.processType.filter(pt => pt.code ==='oral').length!==0)
          this.saveModalWithOral = true;
        else
          this.createModel();
      },
      createModel() {
        // TODO: Nel server il code deve essere generato automaticamente non popolato dal client
        this.modelData.signaturesInfo = JSON.stringify(this.signatures.filter(element => element != '').map((value, index) => { return {order: index, signerRole: value} }));
        this.$http.post(`api/models/`, this.modelData)
          .then(response => response.json())
          .then((data) => {
            this.$router.push({path: `/models/show/${data.id}`})
          })
          .catch((error) => {
            this.errors = error.body.errors;
            error.body.errors.forEach(function (element) {
              miniToastr.error(element.message);
            });
          })
      },
      getTree() {
        this.$http.get(`api/traverse`)
          .then(response => response.json())
          .then(json => {
            this.treeData = json.jasperUriList
            this.treeCda2Data = json.cda2UriList
          })
      },
      nodeSelect(node, isSelected) {
        if (isSelected) {
          this.selectedNode = node.data
        } else if (node.data === this.selectedNode) {
          this.selectedNode = null
        }
      },
      cda2NodeSelect(node, isSelected) {
        if (isSelected) {
          this.cda2SelectedNode = node.data
        } else if (node.data === this.cda2SelectedNode) {
          this.cda2SelectedNode = null
        }
      },
      handleOk(evt) {
        this.myModal = false;
        if (this.selectedNode) {
          this.modelData.jasperUris[this.currentJasperIndex] = this.selectedNode.id
        }
        this.currentJasperIndex = null;
        this.selectedNode = null;
      },
      cda2TemplateModalHandleOk(evt) {
        this.cda2TemplateModal = false;

        if (this.cda2SelectedNode) {
          this.modelData.cda2Uri = this.cda2SelectedNode.id
        }

        this.cda2SelectedNode = null;

      },
      showModal(index) {
        this.currentJasperIndex = index;
        this.myModal = true
      },
      showCda2TemplateModal() {
        this.cda2TemplateModal = true
      },
      removeCda2Uri() {
        this.modelData.cda2Uri = ''
      },
      addElement() {
        this.modelData.jasperUris.push('')
      },
      pullUp(index) {
        this.modelData.jasperUris.splice(index - 1, 0, this.modelData.jasperUris.splice(index, 1)[0]);
      },
      pullDown(index) {
        this.modelData.jasperUris.splice(index + 1, 0, this.modelData.jasperUris.splice(index, 1)[0]);
      },
      removeElement(index) {
        this.modelData.jasperUris.splice(index, 1);
      },
      addSignature() {
        this.signatures.push('')
      },
      pullUpSignature(index) {
        this.signatures.splice(index - 1, 0, this.signatures.splice(index, 1)[0]);
      },
      pullDownSignature(index) {
        this.signatures.splice(index + 1, 0, this.signatures.splice(index, 1)[0]);
      },
      removeSignature(index) {
        this.signatures.splice(index, 1);
      },
      getCategories() {
        this.$http.get(`api/categories/`, {params: {max: -1}})
          .then(response => response.json())
          .then(json => {
            this.categories = json.data
          })
      },
      getProcessType() {
        this.$http.get(`api/processType/`)
          .then(response => response.json())
          .then(json => {
            this.processType = json.data
          })
      },
      getFormats() {
        this.$http.get(`api/models/formats`)
          .then(response => response.json())
          .then(json => {
            this.formats = json.map(function (format) {
              return format.name
            })
          })
      },
      onSearch(search, loading) {
        loading(true);
        this.search(loading, search, this);
      },
      search: _.debounce(async (loading, search, vm) => {
        try {
          let result = await documentTypeService.search({max: -1});
          vm.options = result.data || [];
        } catch (exception) {
          miniToastr.error(exception.message);
        }
        loading(false);
      }, 350)
    }
  }
</script>

<style>
  .error > .clearfix{
    border: 1px solid #f3464a
  }
</style>
